import classnames from 'classnames';
import React from 'react';

import css from './defaultIconStyles.css';

export const IconEdit = ({
    width = '16',
    height = '16',
    className = undefined,
    ...rest
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            className={classnames(css.main, css.colored, className)}
            {...rest}
        >
            <g fillRule="evenodd">
                <path d="M1.975 10.649l6.591-6.591 3.376 3.376-4.903 4.903-1.688 1.688c-.001.001-.378.35-1.108.487l-2.522.477a.685.685 0 0 1-.56-.15.685.685 0 0 1-.15-.56l.477-2.522c.137-.729.485-1.105.487-1.108zm1.01.916a.387.387 0 0 1 .56-.014l.904.904a.386.386 0 0 1 0 .546l-.059.059s-.162.15-.476.209l-1.083.205a.295.295 0 0 1-.241-.064.295.295 0 0 1-.064-.241l.205-1.083c.059-.314.209-.476.209-.476l.045-.045zm9.761-10.272a.999.999 0 0 0-1.414 0L10 2.624 13.376 6l1.331-1.332a.999.999 0 0 0 0-1.414l-1.961-1.961z" />
            </g>
        </svg>
    );
};
export default IconEdit;
